import React from "react";

function PersonCheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="25"
      fill="none"
      viewBox="0 0 31 25"
    >
      <path
        fill="#082478"
        d="M0 24.39v-4.268c0-.838.22-1.626.659-2.363a4.269 4.269 0 011.821-1.677c1.317-.66 2.803-1.22 4.456-1.677 1.654-.457 3.475-.685 5.464-.685.775 0 1.53.038 2.268.114.735.076 1.452.19 2.15.343l-2.713 2.668a4.734 4.734 0 00-.834-.077H12.4c-1.834 0-3.481.216-4.941.648-1.46.432-2.654.902-3.584 1.41-.232.127-.42.305-.561.534a1.411 1.411 0 00-.214.762v1.22h9.688l3.1 3.048H0zm21.003.61l-5.348-5.26 2.17-2.133 3.178 3.125 7.827-7.698L31 15.168 21.003 25zM12.4 12.195c-1.705 0-3.165-.597-4.379-1.791C6.807 9.21 6.2 7.774 6.2 6.098c0-1.677.607-3.113 1.821-4.307C9.235.597 10.695 0 12.4 0c1.705 0 3.165.597 4.379 1.791 1.214 1.194 1.821 2.63 1.821 4.307 0 1.676-.607 3.112-1.821 4.306s-2.674 1.791-4.379 1.791zm0-3.049c.852 0 1.582-.298 2.19-.896.607-.597.91-1.314.91-2.152 0-.839-.303-1.556-.91-2.153a3.012 3.012 0 00-2.19-.896c-.853 0-1.582.299-2.189.896S9.3 5.26 9.3 6.098c0 .838.304 1.555.911 2.152a3.007 3.007 0 002.189.896z"
      ></path>
    </svg>
  );
}

export default PersonCheckIcon;